import { Plane, Rocket, Shield } from 'lucide-react';
import type { MType } from '@/lib/api';
import { cn } from '@/lib/utils';

const ICONS = {
  planes: { Icon: Plane, color: 'text-sky-400', label: 'Planes' },
  rockets: { Icon: Rocket, color: 'text-rose-400', label: 'Rockets' },
  tanks: { Icon: Shield, color: 'text-emerald-400', label: 'Tanks' },
} as const;

export function MTypeIcon({
  type,
  size = 14,
  showLabel = false,
  className,
}: {
  type: MType | null | undefined;
  size?: number;
  showLabel?: boolean;
  className?: string;
}) {
  if (!type) return <span className="text-slate-600">—</span>;
  const { Icon, color, label } = ICONS[type];
  return (
    <span className={cn('inline-flex items-center gap-1', color, className)} title={label}>
      <Icon size={size} />
      {showLabel && <span className="text-xs">{label}</span>}
    </span>
  );
}
